import { Injectable } from '@angular/core';
import {Observable} from 'rxjs/Rx';
// Importación de Angular Fire 2
import { AngularFireAuth } from 'angularfire2/auth';
import { AngularFireDatabase } from 'angularfire2/database';

@Injectable()
export class ServicioGenerarId{
	constructor (public afDB:AngularFireDatabase, public afAuth:AngularFireAuth){}

	idCotizacionConfirmacion(idUsuario:string, inicial:string, inicial_tipoventa:string) {
		let nombreCod:string = '';
		let apellidoPaternoCod:string = '';
		let apellidoMaternoCod:string = '';
		let contadorCotizacion:number = 0;
		var d = new Date();
		let $scope = this;
		var promise = new Promise(function(resolve, reject) {
			try{
			$scope.afDB.object('usuariosPersonal/' + idUsuario + '/informacionPersonal/nombre').valueChanges().take(1).subscribe((nombreDb:string)=>{
	         nombreCod = nombreDb;
		         $scope.afDB.object('usuariosPersonal/' + idUsuario + '/informacionPersonal/apellidoPaterno').valueChanges().take(1).subscribe((apellidoPaternoDb:string)=>{
		         apellidoPaternoCod = apellidoPaternoDb;
			         $scope.afDB.object('usuariosPersonal/' + idUsuario+ '/informacionPersonal/apellidoMaterno').valueChanges().take(1).subscribe((apellidoMaternoDb:string)=>{
			         apellidoMaternoCod = apellidoMaternoDb;
			         	if(inicial =='V'){
			         		$scope.afDB.object('contadores/numeroConfirmaciones').valueChanges().subscribe((cotizacionDb:number)=>{
					         contadorCotizacion = cotizacionDb;
					         	resolve(inicial+inicial_tipoventa + nombreCod.charAt(0) + apellidoPaternoCod.charAt(0) + apellidoMaternoCod.charAt(0) + '-' + d.getFullYear().toString().substring(2,4) + contadorCotizacion);
					        });
			         	} else{
			         		$scope.afDB.object('contadores/numeroCotizaciones').valueChanges().subscribe((cotizacionDb:number)=>{
					         contadorCotizacion = cotizacionDb;
					         	resolve(inicial+inicial_tipoventa + nombreCod.charAt(0) + apellidoPaternoCod.charAt(0) + apellidoMaternoCod.charAt(0) + '-' + d.getFullYear().toString().substring(2,4) + contadorCotizacion);
					        });
			         	}

			        });
		        });
	        });
		}catch(e){
			console.log(e);
		}
		});
		return promise;
	}
}



// WEBPACK FOOTER //
// E:/Github/trosten/trosten-web-app/src/app/services/generar-id.service.ts